module.exports = __webpack_public_path__ + "img/17.64231d57.gif";